import { Box, Chip, Grid, Avatar, Divider, Typography } from "@mui/material";

import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { IListInstancesWhats } from "src/Contexts/Campaign/CampaignContextTypes";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { ModalInstancesWhatsQrCode } from "./Components/GetQrCode";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

import { useState } from "react";
import { formatString } from "@format-string/core";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { ModalDeleteCore } from "src/Pages/components";
import { DeleteForeverIcon } from "src/Pages/components/Icons/Icons";
import LogoutIcon from "@mui/icons-material/Logout";
import { api } from "src/shared/setup/API/api";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { RotatingCachedIcon } from "src/Pages/components/Icons/RotatingCachedIcon";

interface ICardInstancesWhats {
  data: IListInstancesWhats;
  loadingTable: boolean;
}

export const CardInstancesWhats = ({
  data,
  loadingTable,
}: ICardInstancesWhats) => {
  const [openModalQrCode, setOpenModalQrCode] = useState(false);

  const { handleGetAlert } = useLayoutMainContext();
  const { setAttTable } = useConfigPageContext();

  const handleLogout = async (id: string) => {
    await api
      .patch(`/instancesWhats/${id}/logout`)
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
      })
      .catch((error) => {
        handleGetAlert({ message: error.response.data.message });
      });
  };

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/instancesWhats" });

  const objStatus = {
    open: "Conectado",
    created: "Criado",
    connecting: "Desconectado",
    close: "Desconectado",
  };

  return (
    <>
      <ModalInstancesWhatsQrCode
        id={data.id}
        openModal={openModalQrCode}
        setOpenModal={setOpenModalQrCode}
      />

      <ModalDeleteCore
        loading={loadingDelete}
        modalOpen={openModalDelete}
        no="Não, Cancelar"
        titlePrimary="Você deseja excluir da lista ?"
        yes="Sim, Deletar !"
        onClickFalse={() => setOpenModalDelete(false)}
        onClickTrue={() => handleDelete()}
      />

      <Grid item xs={12} lg={4} key={data.id}>
        <CardCore sxStyle={{ margin: 0, mb: "12px", width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography>{data.title}</Typography>

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Chip
                label={objStatus[data.status]}
                color={
                  objStatus[data.status] === "Conectado" ? "success" : "error"
                }
                size="small"
                sx={{ mr: "12px" }}
              />

              <RotatingCachedIcon
                onClick={() => setAttTable((item) => !item)}
                isLoading={loadingTable}
                tooltipTitle="Recarregar a página"
                iconButtonSx={{ margin: 0, padding: 0 }}
              />

              {/* <IconButton
                sx={{ margin: 0, padding: 0, mr: "12px" }}
                onClick={() => setAttTable((item) => !item)}
              >
                <CachedIcon sx={{ cursor: "pointer" }} />
              </IconButton> */}
            </Box>
          </Box>

          <Divider sx={{ margin: "24px 0" }} />

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar
              sx={{ marginRight: "12px" }}
              src={data.urlImage || data.title.toUpperCase()}
            />
            <Box>
              <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                {data.number
                  ? formatString({
                      type: "phone",
                      value: data.number,
                    })
                  : "Número: Ainda não capturado"}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "30px",
            }}
          >
            <ButtonCore
              title="Deletar"
              size="small"
              variant="outlined"
              color="error"
              endIcon={
                <DeleteForeverIcon sx={{ cursor: "pointer" }} color={"error"} />
              }
              onClick={() => {
                setIdModalDelete(data.id);
                setOpenModalDelete(true);
              }}
            />
            {data.status !== "open" ? (
              <ButtonCore
                size="small"
                color="success"
                title="Ler QRCode"
                variant="outlined"
                onClick={() => setOpenModalQrCode(true)}
                endIcon={
                  <QrCodeScannerIcon
                    sx={{ cursor: "pointer" }}
                    color={"success"}
                  />
                }
              >
                Delete
              </ButtonCore>
            ) : (
              <ButtonCore
                size="small"
                color="warning"
                title="Desconectar"
                variant="outlined"
                onClick={() => handleLogout(data.id)}
                endIcon={
                  <LogoutIcon sx={{ cursor: "pointer" }} color={"warning"} />
                }
              >
                Desconectar
              </ButtonCore>
            )}
          </Box>
        </CardCore>
      </Grid>
    </>
  );
};
